<script lang="ts">
	export let gradient = 'bg-fx-gradient-12';
	export let outerClassList = '';
	export let innerClassList = '';
	export let paddingClass = '';
	export let borderRadius = '';
</script>

<div class="{gradient} {paddingClass} {borderRadius} {outerClassList} ">
	<div class="{innerClassList} {borderRadius} w-full h-full">
		<slot />
	</div>
</div>

<style>
</style>
